// @file init.js
// this file is loaded in head
// Before anything, check if the client is using outdated browser
window.addEventListener('load', function() {
  var browser = window.navigator.userAgent.match(/(MSIE|Trident)/);
  if(browser) {
    var content = Cacoo.SiteResources["unsupported_browser"];
    if(!content) {
      content = "Cacoo does not support your current browser. Please use the latest version of Chrome, Firefox, Safari, or Microsoft Edge."
    }
    alert(content);
  }
});

var modernizr = require('./vendor/modernizr');
